import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { EventEmitter,Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "app/@core/services/http.service";
import { AppSettings } from "app/app-settings";
import { environment } from "environments/environment";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ActivityFeedsService {
  public refreshAfterEditDeleteChanges: EventEmitter<any> = new EventEmitter();

  constructor(public httpService: HttpService, public http: HttpClient,public dialog: MatDialog) {}

  getAnomalies() {
    return this.httpService
      .get(AppSettings.API_ANOMALIES)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  //anomalyStatus = all, true, false
  exportFile(
    date,
    anomalyStatus,
    exportType,
    fromDate,
    tillDate,
    fromChainage,
    toChainage,
    selectedAssets
  ) {
    var params = new HttpParams()
      .set("date", date.toString())
      .set("anomalyStatus", anomalyStatus)
      .set("exportType", exportType)
      .set("fromDate", fromDate)
      .set("tillDate", tillDate)
      .set("fromChainage", fromChainage)
      .set("toChainage", toChainage)
      .set("assets", selectedAssets);
    return this.httpService
      .get(AppSettings.API_ANOMALIES_EXPORTFILE, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      alert("Please disable your Pop-up blocker and try again.");
    }
  }

  updateAnomaly(anomaly, isRectificationEnabled) {
    /*bulk audit changes,since anomaly contains morethan 1 anomaly,for loop is used to remove 2 properties */
    anomaly.forEach((data) =>{
      if(data && data.Extra_Master_Position !== null && data.Extra_Master_Position !== undefined && data.Extra_Master_Position !== ''){
        delete data.Extra_Master_Position;
      }
      if(data && data.Extra_Master_Chainage !== null && data.Extra_Master_Chainage !== undefined && data.Extra_Master_Chainage !== ''){
        delete data.Extra_Master_Chainage;
      }
    })
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    if(loggedInUser && loggedInUser.db_name && loggedInUser.db_name != undefined && loggedInUser.db_name != null && loggedInUser.db_name != ''){
      var params = new HttpParams()
      .set("dbName", loggedInUser["db_name"])
      .set("isRectificationEnabled", isRectificationEnabled);
    return this.http
      .post(AppSettings.API_ANOMALIES, anomaly, { params })
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
    } 
    else{
      return of({ error: "getDbName is not available" });
    }
  }

  /*edit/delete option for audited anomalies*/
  getAuditedData(
    fromDate = "",
    tillDate = "",
    fromChainage = "",
    toChainage = "",
    assets = "",
    pageNo = 0,
    pageSize = 50,
    videoName = "",
    assetsIds = "",
    site_ids = ""
  ){
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    let org_id = loggedInUser.org_id;
    var params = new HttpParams()
      .set("fromDate", fromDate)
      .set("tillDate", tillDate)
      .set("fromChainage", fromChainage)
      .set("toChainage", toChainage)
      .set("assets", assets)
      .set("assetsIds", assetsIds)
      .set("pageNo", pageNo.toString())
      .set("pageSize", pageSize.toString())
      .set("dbName", loggedInUser["db_name"])
      .set("videoName", videoName)
      // .set("org_id", org_id)
      .set("site_ids", site_ids);
    return this.httpService
      .get(AppSettings.API_GET_AUDITED_DATA, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }
  
  getHistory(
    date,
    fromDate = "",
    tillDate = "",
    fromChainage = "",
    toChainage = "",
    assets = "",
    pageNo = 0,
    pageSize = 50,
    sortByDateAsc = false,
    videoName = "",
    assetsIds = "",
    isRectificationEnabled = false,
    isTrueFalse = "" /**true/false filter changes */,
    features = "", // adding feature as another filter option,
    anomalyIds = "" ,//SearchBy ID
    auto_audit = ''  
  ) {
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const selectedSiteIds = localStorage.getItem("selectedSite");
         //feature, unproceed API n 'Service Road' option
    let sortByDate : any = localStorage.getItem("sortByDateAsc");
    if(sortByDate != '' && sortByDate != null && sortByDate != undefined && sortByDate != "null"){
      sortByDate = (sortByDate === 'true') ? true : false;
    }
    else{
      sortByDate = false;
    }
if(features === '' || features.length === 0){
   if(!isRectificationEnabled){ 
    var params = new HttpParams()
    .set("date", date.toString())
    .set("fromDate", fromDate)
    .set("tillDate", tillDate)
    .set("fromChainage", fromChainage)
    .set("toChainage", toChainage)
    .set("assets", assets)
    .set("assetsIds", assetsIds)
    .set("pageNo", pageNo.toString())
    .set("pageSize", pageSize.toString())
    .set("sortByDateAsc", "" + sortByDate)
    .set("dbName", loggedInUser["db_name"])
    .set("videoName", videoName)
    .set("isRectificationEnabled", String(isRectificationEnabled))
    .set("siteIds", selectedSiteIds ? selectedSiteIds : "")
    .set("anomalyIds", anomalyIds ? anomalyIds : "")  //SearchBy ID
    .set("isTrueFalse", isTrueFalse)
    .set("auto_audit", auto_audit);
  }
  else{
    var params = new HttpParams()
    .set("date", date.toString())
    .set("fromDate", fromDate)
    .set("tillDate", tillDate)
    .set("fromChainage", fromChainage)
    .set("toChainage", toChainage)
    .set("assets", assets)
    .set("assetsIds", assetsIds)
    .set("pageNo", pageNo.toString())
    .set("pageSize", pageSize.toString())
    .set("sortByDateAsc", "" + sortByDateAsc)
    .set("dbName", loggedInUser["db_name"])
    .set("videoName", videoName)
    .set("isRectificationEnabled", String(isRectificationEnabled))
    .set("siteIds", selectedSiteIds ? selectedSiteIds : "")
    .set("anomalyIds", anomalyIds ? anomalyIds : "")  //SearchBy ID
    .set("isTrueFalse", isTrueFalse);
  }
}
else{
  if(!isRectificationEnabled){ 
    var params = new HttpParams()
      .set("date", date.toString())
      .set("fromDate", fromDate)
      .set("tillDate", tillDate)
      .set("fromChainage", fromChainage)
      .set("toChainage", toChainage)
      .set("assets", assets)
      .set("assetsIds", assetsIds)
      .set("pageNo", pageNo.toString())
      .set("pageSize", pageSize.toString())
      .set("sortByDateAsc", "" + sortByDateAsc)
      .set("dbName", loggedInUser["db_name"])
      .set("videoName", videoName)
      .set("isRectificationEnabled", String(isRectificationEnabled))
      .set("features", features)  // adding feature as another filter option
      .set("siteIds", selectedSiteIds ? selectedSiteIds : "")
      .set("anomalyIds", anomalyIds ? anomalyIds : "")  //SearchBy ID
      .set("isTrueFalse", isTrueFalse)
      .set("auto_audit", auto_audit); /**true/false filter changes */
  }
  else{
    var params = new HttpParams()
      .set("date", date.toString())
      .set("fromDate", fromDate)
      .set("tillDate", tillDate)
      .set("fromChainage", fromChainage)
      .set("toChainage", toChainage)
      .set("assets", assets)
      .set("assetsIds", assetsIds)
      .set("pageNo", pageNo.toString())
      .set("pageSize", pageSize.toString())
      .set("sortByDateAsc", "" + sortByDateAsc)
      .set("dbName", loggedInUser["db_name"])
      .set("videoName", videoName)
      .set("isRectificationEnabled", String(isRectificationEnabled))
      .set("features", features)  // adding feature as another filter option
      .set("siteIds", selectedSiteIds ? selectedSiteIds : "")
      .set("anomalyIds", anomalyIds ? anomalyIds : "")  //SearchBy ID
      .set("isTrueFalse", isTrueFalse);
  }
}
let clearCache = this.httpService
      .get(AppSettings.CLEAR_ALL_CACHE)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));

    return this.httpService
      .get(AppSettings.API_ANOMALIES_History, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

    // video are not according to site,history & rectification history dates are same,uncomment below method
  getHistoryDates(isRectificationEnabled:boolean) {
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const selectedSiteIds = localStorage.getItem("selectedSite");
    var params = new HttpParams()
      .set("dbName", loggedInUser["db_name"])
      .set("isRectificationEnabled", String(isRectificationEnabled))
      .set("siteIds", selectedSiteIds ? selectedSiteIds : "");
    return this.httpService
      .get(AppSettings.API_ANOMALIES_HistoryDates, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  getAssets() {
    return this.httpService
      .get(AppSettings.API_ASSET_STATUS)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  getNotifications() {
    return this.httpService
      .get(AppSettings.API_NOTIFICATION_ALL)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  getOrganizationSites(organizationId) {
    const params = new HttpParams().append("org_id", organizationId);
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let headers: any = new HttpHeaders({ "x-access-token": user.access_token });
    return this.httpService
      .get(`${AppSettings.API_ORGANIZATION_SITES}`, params, headers)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  markNotificationsViewed() {
    return this.httpService
      .get(AppSettings.API_NOTIFICATION_VIEWED)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  markNotificationDeleted(id) {
    var params = new HttpParams().set("id", id.toString());
    return this.httpService
      .get(AppSettings.API_NOTIFICATION_DELETE, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  updateAnomalyInDashboard(data: any) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let headers: any = new HttpHeaders({ "x-access-token": user.access_token });

    return this.httpService
      .post(AppSettings.API_DASHBOARD_UPDATE_ANOMALY,data,headers);
  }

  updateAnomalyInDashboardFromRect(data: any) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let headers: any = new HttpHeaders({ "x-access-token": user.access_token });
    return this.httpService
      .post(AppSettings.Rect_false,data,headers);
  }
  
  completeAnomaly(anomaly: any) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let headers: any = new HttpHeaders({ "x-access-token": user.access_token });
    return this.httpService
      .post(AppSettings.API_DASHBOARD_COMPLETE_ANOMALY, anomaly, headers);
  }

  getVideoNames() {
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const selectedSiteIds = localStorage.getItem("selectedSite");
    var params = new HttpParams()
      .set("dbName", loggedInUser["db_name"])
      .set("siteIds", selectedSiteIds ? selectedSiteIds : "");
    return this.httpService
      .get(AppSettings.GET_VIDEO_NAMES, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  } 
  
  getFalsePositiveData(
  fromDate = "",
  tillDate = "",
  fromChainage = "",
  toChainage = "",
  pageNo = 0,
  pageSize = 50,
  sortByDateAsc = false,
  videoName = "",
  assetsIds = "",
) {
  let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const selectedSiteIds = localStorage.getItem("selectedSite");
  var params = new HttpParams()
  .set("fromDate", fromDate)
  .set("tillDate", tillDate)
  .set("fromChainage", fromChainage)
  .set("toChainage", toChainage)
  .set("assetsIds", assetsIds)
  .set("pageNo", pageNo.toString())
  .set("pageSize", pageSize.toString())
  .set("sortByDateAsc", "" + sortByDateAsc)
  .set("videoName", videoName)
  .set("siteIds", selectedSiteIds ? selectedSiteIds : "");

  return this.httpService
    .get(AppSettings.GET_FALSE_POSITIVE_DATA, params)
    .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
}

/* updateImage from  an video*/
  extractImage(
    frameTime ="",
    totalTime= '',
    anomalyId = "",
    imagePathToBeReplaced = "",
    isRectificationEnabled = false
  ) {
    const selectedSiteIds = localStorage.getItem("selectedSite");
    var params = new HttpParams()
      .set("frameTime", frameTime)
      .set("anomalyId", anomalyId)
      .set("totalTime", totalTime)
      .set("imagePath", imagePathToBeReplaced)
      .set("isRectificationEnabled", String(isRectificationEnabled))
      .set("siteIds", selectedSiteIds ? selectedSiteIds : '');
      let url = AppSettings.DASHBOARD_END_POINT + "/AuditPage/auditor/extract-images";
    return this.httpService
      .get(url, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

/*edit/delete option for audited anomalies*/
  updateAuditedAnomaly(site_id ='',anomaly_id = '',test_image :string,master_image: string,pos='',chainage= '',comment = '',side = '',audit_value = '',updated_user_name :string= ''){
    let user_name = updated_user_name + ',' + JSON.parse(localStorage.getItem('currentUser')).username;

    let anomaly :any = {};
    anomaly.master_image = master_image;
    anomaly.test_image = test_image;
    anomaly.updated_user_name = user_name;

  let url = AppSettings.UPDATE_AUDITED_ANOMALY +'/' + site_id+ '/' +anomaly_id  +
  '?audit_value=' + audit_value + 
  '&chainage=' + chainage+ 
  '&comment=' + comment+ 
  '&side=' + side+ 
   '&pos=' + pos;
  return this.http.put(url,anomaly )
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

deleteAuditedAnomaly(
  site_id = '',
  anomaly_id = '',
  test_image = '',
  master_image = '',
  pos = '',
  chainage = '',
  comment = '',
  side = '',
  audit_value = '',
  deleted_user_name:string = ''
) {
  
  let url = AppSettings.DELETE_AUDITED_ANOMALY +'/' + site_id+ '/' +anomaly_id+ 
  '?audit_value=' + audit_value + 
  '&chainage=' + chainage+ 
  '&comment=' + comment+ 
  '&side=' + side+ 
   '&pos=' + pos;
   let user_name  = deleted_user_name  + ',' + JSON.parse(localStorage.getItem('currentUser')).username;

  const params  = {
    master_image: master_image,
    test_image: test_image,
    deleted_user_name: user_name 
  };

  return this.http
  .request('delete', url, { body: params })
    .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
}

// auto audit changes
// getAutoAudited(
//   date,
//   fromDate = "",
//   tillDate = "",
//   fromChainage = "",
//   toChainage = "",
//   assets = "",
//   pageNo = 0,
//   pageSize = 50,
//   sortByDateAsc = false,
//   videoName = "",
//   assetsIds = "",
//   isRectificationEnabled = false,
//   isTrueFalse = "" /**true/false filter changes */
// ) {
//   let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//   const selectedSiteIds = localStorage.getItem("selectedSite");

//   var params = new HttpParams()
//     .set("date", date.toString())
//     .set("fromDate", fromDate)
//     .set("tillDate", tillDate)
//     .set("fromChainage", fromChainage)
//     .set("toChainage", toChainage)
//     .set("assets", assets)
//     .set("assetsIds", assetsIds)
//     .set("pageNo", pageNo.toString())
//     .set("pageSize", pageSize.toString())
//     .set("sortByDateAsc", "" + sortByDateAsc)
//     .set("dbName", loggedInUser["db_name"])
//     .set("videoName", videoName)
//     .set("isRectificationEnabled", String(isRectificationEnabled))
//     .set("siteIds", selectedSiteIds ? selectedSiteIds : "")
//     .set("isTrueFalse", isTrueFalse); /**true/false filter changes */

//   return this.httpService
//     .get(AppSettings.API_ANOMALIES_AUTO_AUDITED, params)
//     .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
// }

// submitAutoAudits() {
//   let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//   const selectedSiteIds = localStorage.getItem("selectedSite");
//   var params = new HttpParams()
//     .set("dbName", loggedInUser["db_name"])
//     .set("siteIds", selectedSiteIds ? selectedSiteIds : "");
//   return this.httpService
//     .get(AppSettings.API_ANOMALIES_SUBMIT_AUTO_AUDITS, params)
//     .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
// }

clearCache(){
  return this.httpService
  .get(AppSettings.CLEAR_ALL_CACHE)
  .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
}

bulkDelete(deleteDetails) {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let headers: any = new HttpHeaders({ "x-access-token": user.access_token });
    return this.http
    .post(`${AppSettings.API_BULK_DELETE}`, deleteDetails)
    .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
}

  markAsUnderReview(id: any,isRectificationEnabled : any) {
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser"));
    let headers: any = new HttpHeaders({ "x-access-token": loggedInUser.access_token });
    let url = AppSettings.API_UNDER_REVIEW_AN_ANOMALY + '?id=' + id + '&dbName=' + loggedInUser["db_name"] + '&userName=' +  loggedInUser["email"]
    + '&isRectificationEnabled=' +  isRectificationEnabled ;
    return this.httpService
      .get(url)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  getDeletedAudits(
    fromDate = '',
    tillDate = '',
    pageNo = 0,
    pageSize = 50,
    dbName = '',
    site_id = '',
    asset_id = ''
  ){
    let site_ids : any;
    let selectedSiteIds = localStorage.getItem("selectedSite");
    if (selectedSiteIds != null && selectedSiteIds != undefined && selectedSiteIds != '') {  
      site_ids = selectedSiteIds;
    }
    let loggedInUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    var params = new HttpParams()
      .set("fromDate", fromDate)
      .set("toDate", tillDate)
      .set("page", (pageNo).toString())
      .set("limit", pageSize.toString())
      .set("dbName", loggedInUser.db_name)
      .set("asset_id", asset_id)
      .set("site_id", site_ids);
    return this.httpService
      .get(AppSettings.getDeletedAudits, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }

  getFalseAnomaly(
    dbName = '',
    site_id = '',
    fromDate = '',
    tillDate = '',
    asset_id = '',
    pageNo = 0,
    pageSize = 50,
  ){
    var params = new HttpParams()
      .set("dbName", dbName)
      .set("fromDate", fromDate)
      .set("toDate", tillDate)
      .set("asset_id", asset_id)
      .set("page", (pageNo + 1).toString())
      .set("limit", pageSize.toString())
      .set("site_id", site_id);
    return this.httpService
      .get(AppSettings.getFalseAnomaly, params)
      .pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }
}
